const REDBROWN = '#AA5939'
// const BROWN = '#AA7939'
const BLUE = '#294F6D'
const GREEN = '#277554'
const RED = 'rgb(198, 44, 19)'
const PURPLE = '#A6373F'
const ORANGE = '#DE8C1F'
const TEAL = '#236467'
const AFD = '#009EE0'
// const WHITE = '#FFFFFF'

export const IconLook = {
  'thinktank': {
    color: REDBROWN,
    fa: 'far fa-lightbulb',
  },
  'medium': {
    color: GREEN,
    fa: 'fab fa-readme',
  },
  'partei': {
    color: AFD,
    fa: 'fas fa-university',
  },
  'verlag': {
    color: BLUE,
    fa: 'fas fa-book',
  },
  'finanzier': {
    color: ORANGE,
    fa: 'fas fa-donate',
  },
  'kampagne': {
    color: RED,
    fa: 'fas fa-bullhorn',
  },
}



// WEBPACK FOOTER //
// ./src/icon_look.js